import React from "react";

const NavContext = React.createContext();

export default NavContext;